/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnProgramSessionUpdateStrategy } from './en-program-session-update-strategy';
import { UpdateSessionDto } from './update-session-dto';
 /**
 *
 *
 * @export
 * @interface UpdateProgramSessionDto
 */
export interface UpdateProgramSessionDto {

    /**
     * Delay in SECONDS from the assignment start at which this session is scheduled. Day 0 is 0, day 1 is 86400. Not milliseconds — the value is consumed as seconds when the program is assigned.
     *
     * @type {number}
     * @memberof UpdateProgramSessionDto
     */
    offset: number;

    /**
     * @type {string}
     * @memberof UpdateProgramSessionDto
     */
    note?: string | null;

    /**
     * @type {number}
     * @memberof UpdateProgramSessionDto
     */
    id: number;

    /**
     * How to apply a `session` content edit when the referenced session is a shared TEMPLATE. Omitted, the edit is refused with 428 Precondition Required (PROGRAM.UPDATE_REQUIRES_CONFIRMATION): a template is never mutated from inside a therapy. `clone` confirms forking a private copy owned by this therapy — the template and every other therapy stay untouched, and the change reaches only this program’s future assignments. Ignored when the referenced session is already a one-off (it is edited in place) or when no `session` edit is sent.
     *
     * @type {EnProgramSessionUpdateStrategy}
     * @memberof UpdateProgramSessionDto
     */
    strategy?: EnProgramSessionUpdateStrategy;

    /**
     * @type {UpdateSessionDto}
     * @memberof UpdateProgramSessionDto
     */
    session?: UpdateSessionDto;
}
